
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FileText } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const NoReportsFound: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="text-center py-8">
      <FileText className="h-12 w-12 mx-auto text-gray-300 mb-3" />
      <p className="text-gray-500">{t('reports.noneSaved')}</p>
      <Link to="/form">
        <Button className="mt-4 bg-form-blue hover:bg-form-light-blue">
          {t('reports.newReport')}
        </Button>
      </Link>
    </div>
  );
};
